import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import Toast from 'vue-toastification'
import VueApexCharts from 'vue3-apexcharts'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

import 'vue-toastification/dist/index.css'
import './assets/styles/main.css'

// i18n messages
const messages = {
  'pt-BR': {
    common: {
      loading: 'Carregando...',
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      create: 'Criar',
      search: 'Buscar',
      filter: 'Filtrar',
      export: 'Exportar',
      refresh: 'Atualizar',
      confirm: 'Confirmar',
      success: 'Sucesso',
      error: 'Erro',
      warning: 'Atenção',
      info: 'Informação',
    },
    nav: {
      dashboard: 'Dashboard',
      zones: 'Zonas DNS',
      records: 'Registros',
      servers: 'Servidores',
      analytics: 'Analytics',
      audit: 'Auditoria',
      settings: 'Configurações',
      docs: 'Documentação API',
    },
    dashboard: {
      title: 'Visão Geral',
      totalQueries: 'Total de Consultas',
      queriesPerSecond: 'Consultas/Segundo',
      cacheHitRate: 'Taxa de Cache',
      activeZones: 'Zonas Ativas',
      serverStatus: 'Status dos Servidores',
      recentActivity: 'Atividade Recente',
    },
  },
  en: {
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      refresh: 'Refresh',
      confirm: 'Confirm',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
    },
    nav: {
      dashboard: 'Dashboard',
      zones: 'DNS Zones',
      records: 'Records',
      servers: 'Servers',
      analytics: 'Analytics',
      audit: 'Audit',
      settings: 'Settings',
      docs: 'API Documentation',
    },
    dashboard: {
      title: 'Overview',
      totalQueries: 'Total Queries',
      queriesPerSecond: 'Queries/Second',
      cacheHitRate: 'Cache Hit Rate',
      activeZones: 'Active Zones',
      serverStatus: 'Server Status',
      recentActivity: 'Recent Activity',
    },
  },
}

const i18n = createI18n({
  legacy: false,
  locale: 'pt-BR',
  fallbackLocale: 'en',
  messages,
})

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueApexCharts)
app.use(Toast, {
  position: 'top-right',
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
})

// Initialize auth state
const authStore = useAuthStore()
authStore.initAuth()

// Hide loader when app is mounted
app.mount('#app')

// Remove loader
const loader = document.getElementById('app-loader')
if (loader) {
  loader.classList.add('fade-out')
  setTimeout(() => loader.remove(), 300)
}
